<template>
  <div class="sp">
    <div class="sp-brew" :style="{ width: scrollProgress + '%' }"></div>

    <header class="sp-nav" :class="{ 'sp-scrolled': scrolled }">
      <a class="sp-lockup" @click="$router.push('/')">
        <img src="../assets/tcb-cup.png" alt="The Coffee Break cup logo" />
        <span>The Coffee Break</span>
      </a>
      <div class="sp-nav-actions">
        <div class="sp-menu-wrap" ref="menuWrap">
          <button
            class="sp-menu-btn"
            @click="menuOpen = !menuOpen"
            :aria-expanded="menuOpen"
          >
            Menu
          </button>
          <div class="sp-menu-dropdown" :class="{ 'sp-menu-open': menuOpen }">
            <a @click="goto('/')">Home</a>
            <a @click="goto('/about')">About</a>
            <a @click="goto('/career')">Career</a>
            <a @click="goto('/terms-of-service')">Terms of Service</a>
            <a @click="goto('/ilovetcb')">
              <svg class="sp-heart" viewBox="0 0 24 24" width="14" height="14" fill="currentColor" aria-hidden="true">
                <path
                  d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"
                ></path>
              </svg>
              Support Us
            </a>
          </div>
        </div>
        <button class="sp-cta" @click="focusFinalEmail">Subscribe — Free</button>
      </div>
    </header>

    <main>
      <section class="ab-legal-hero">
        <div class="sp-wrap">
          <div class="sp-kicker" v-reveal>Legal</div>
          <h1 class="sp-display ab-legal-title">
            <span class="sp-row"><span>Privacy</span></span>
            <span class="sp-row"><span><em class="sp-cupword">Policy.</em></span></span>
          </h1>
        </div>
      </section>

      <section class="ab-legal">
        <div class="sp-wrap ab-legal-wrap" v-reveal>
          Finlit Media Tech Group Sdn Bhd. (“FMTG” or “we”, “our” or “us”) operates The Coffee
          Break services, which includes a newsletter and a website (collectively, the
          “Services”).
          <br /><br />
          We respect the privacy of users of the Services. This Privacy Policy supplements our
          Terms of Service and is intended to educate you on our policies and practices
          regarding the collection, use and disclosure of any Personal Information (defined
          below) and Anonymous Information (defined below).
          <br /><br />
          Please review this Privacy Policy carefully. By using or accessing the Services,
          signing up for newsletters or subscribing to podcasts and/or communicating with us,
          you are accepting the terms of this Privacy Policy.
          <br /><br />
          <h5>1. USER CONSENT/LEGAL BASIS</h5>

          “Personal Information” is information about you that is personally identifiable to
          you, like your name, address, and email address, as well as other non-public
          information that is associated with the foregoing. “Anonymous Information” is
          information that is not associated with or linked to your Personal Information;
          Anonymous Information does not allow the identification of individual persons. We
          collect and use Personal Information and Anonymous Information as indicated in this
          Privacy Policy.
          <br /><br />
          When you submit any Personal Information through the Services, you agree to the terms
          of this Privacy Policy and you expressly consent to the treatment of your Personal
          Information defined in this Privacy Policy.
          <br /><br />
          Other legal basis for collecting Personal Information are: (i) where we need the
          Personal Information for performance of a contract or requested service; or (ii)
          where the collection and use is in our or another’s legitimate interests and not
          overridden by your data protection interests or fundamental rights and freedoms. In
          some cases, we may also have a legal obligation to collect the Personal Information in
          question. If we collect your Personal Information with your consent, you may have the
          right to withdraw your consent at any time by contacting us as per below.
          <br /><br />

          <h5>2. INFORMATION COLLECTED</h5>
          We may collect Personal Information that you submit to us directly through the
          Services, and via passive technologies integrated into the Services, including via
          third parties.
          <br /><br />
          You may directly submit information to us when you subscribe to a newsletter or
          podcast, order a product (such as our paid products), purchase merchandise, answer
          survey questions, or use other methods of submitting information. The types of
          information you can choose to provide on the Services includes:
          <br /><br />
          <ul>
            <li>Name, email address, zip/postal code, physical location information and contact information.</li>
            <li>Billing and shipping addresses, credit card number, and expiration date.</li>
            <li>Personal Information you choose to provide, including your age, gender, race/ethnicity, job title and role, industry, and employer information.</li>
          </ul>
          <br />
          The Services also passively collect certain types of Personal Information and
          Anonymous Information, including through third parties. We may use pixel tags,
          cookies, and/or other similar technologies to collect this information. We do not use
          any such technologies to conduct online targeted advertising
          <br /><br />
          Please also note that most web browsers automatically accept cookies and other
          tracking technologies, but if you prefer, you may be able to edit your browser options
          to block them. Visitors to the Services who disable cookies will be able to browse
          most areas of the Services, but some features may not function. You can find out more
          information about how to change your browser cookie settings at
          www.allaboutcookies.org. Further, the Services do not currently recognize “Do Not
          Track” settings or technologies.
          <br /><br />
          <h5>3. USE OF INFORMATION</h5>
          We may use your Personal Information for the following general and business purposes:
          <ul>
            <li>To deliver Services.</li>
            <li>To fulfill or respond to your inquiries.</li>
            <li>To address administrative needs and communications.</li>
            <li>To improve Services.</li>
            <li>
              To contact you for internal business purposes or for marketing communications
              purposes. You may always choose not to receive marketing communications from GDBS
              by following the unsubscribe instructions set out in our communications.
            </li>
            <li>To provide notice of changes and upgrades to Services.</li>
          </ul>
          <br /><br />
          We may use both manual and automated systems, such as machine learning and artificial
          intelligence, to: analyze Personal Information and Anonymous Information to improve
          our Services; personalize your experience; automate certain aspects of the Services;
          aggregate and anonymize information; provide you certain features; and protect the
          safety and security of our Services.
          <br />
          We use Anonymous Information such as web or mobile pages you have viewed, in order to
          analyze request and usage patterns so that we may improve our products and services,
          enhance our user experience, and gather broad demographic information for aggregate
          use.
          <br /><br />
          <h5>4. INFORMATION SHARING</h5>
          We do not sell, trade, rent, or share your Personal Information with third parties for
          their marketing purposes, and we will not disclose financial information that is part
          of your Personal Information, in each case unless you request or authorize that we do
          so.
          <br /><br />
          <ul>
            <li>
              i. Affiliated Entities We may disclose Personal Information to our corporate
              subsidiaries or affiliated entities which operate under our same internal
              processes and policies. Any Personal Information provided to our subsidiaries or
              entities affiliated with us will be treated by those subsidiaries and affiliated
              entities in accordance with the terms of this Privacy Policy.
            </li>
            <li>
              ii. Service Providers We may share your Personal Information with third party
              vendors and suppliers that help us provide our Services to you. These third
              parties provide services to us, such as email delivery services (for instance, to
              send you newsletters), data hosting, customer relationship management, and data
              analytics. You expressly consent to the sharing of your Personal Information with
              our contractors and third-party service providers (for the sole purpose of
              providing products and services to you. These service providers are contractually
              obligated to ensure the confidentiality of Personal Information and implement
              appropriate security measures.
            </li>
            <li>
              iii. Payment Processors We use third-party payment processors for any purchases
              you make through the Services. You can read more about how Stripe uses your
              Personal Information here: https://stripe.com/privacy. Be advised that we do not
              have access to any Personal Information, including credit card numbers or other
              financial information, you provide to these processors. This Privacy Policy does
              not apply to them, and we do not accept any responsibility or liability for their
              policies. We encourage you to review the privacy policies of these third-party
              providers.
            </li>
            <li>
              iv. Partner Companies We may participate in co-branding or co-promotional
              agreements with third parties pursuant to which we may share Personal Information
              with such third parties (“Partner Companies”). For example, we may participate in
              agreements with Partner Companies pursuant to which we provide the Partner
              Companies with a URL and a customer registration page co-branded with, or private
              labeled by, the Partner Companies, and the Partner Companies distribute and
              promote the URL to its customers. A Partner Company may have access to Personal
              Information that we collect from their customers. As a result, if you register for
              the Services through a Partner Company, we may provide your Personal Information
              to the Partner Company. We do not control the privacy practices of these Partner
              Companies and we encourage you to review their privacy policies. Under the
              following scenarios, we may be required or authorized by law to share your
              Personal Information:
              <ul>
                <li>
                  If we believe it is necessary to share information in order to investigate,
                  prevent or take action regarding illegal activities, suspected fraud,
                  situations involving possible threats to the physical safety of any person,
                  violations of our Terms of Use or as otherwise required by law.
                </li>
                <li>
                  If we respond to subpoenas, court orders or legal process, or if we need to
                  establish or exercise our legal rights or defend against legal claims.
                </li>
                <li>
                  If we believe it is necessary to restrict or inhibit any user from using any of
                  the Services, including, without limitation, by means of “hacking” or defacing
                  any portion thereof.
                </li>
              </ul>
            </li>
          </ul>
          <br />
          We may use your Personal Information in order to provide to third parties
          non-personal aggregated information that does not allow you to be identified or
          contacted and that is combined with the Personal Information of other users
          (“Aggregate Information”). For example, we might inform third parties regarding the
          number of users of the Services and the activities they conduct while on the Services.
          We might also inform a company that performs services or that provides products
          and/or services to us (that may or may not be a business partner or an advertiser on
          the Services) that “50% of our users live in the Malaysia” or that “85% of our users
          have purchased products and/or services which can be downloaded from the Services”.
          Depending on the circumstances, we may or may not charge third parties for this
          Aggregate Information. We may not limit the third parties’ use of the Aggregate
          Information.
          <br /><br />
          We may disclose Anonymous Information to third parties that promote our products and
          services. We reserve the right to use and disclose Anonymous Information to third
          parties at our discretion.
          <br /><br />
          <h5>5. OPT-OUT OF MARKETING EMAILS OR NEWSLETTERS</h5>
          When you receive promotional communications or newsletters from us, you may “opt-out”
          by following the unsubscribe instructions indicated in the communication you
          receive.. We may continue to send you communications regarding the Services, such as
          notices about administrative updates, transaction reports, and changes to the
          Services, this Privacy Policy or the Terms of Service. Where applicable, please refer
          to our Privacy Notice.
          <br /><br />
          <h5>6. SECURITY</h5>
          FMTG has implemented technical, administrative and physical security measures to
          protect your information from loss or theft, as well as unauthorized access, use or
          disclosure. While we strive to protect your information, no data transmission over
          the Internet is 100% secure and, consequently, we cannot guarantee or warrant the
          security of any information you provide, and you do so at your own risk. We cannot
          promise that your information will remain absolutely secure in all circumstances. We
          are not responsible for the circumvention of any privacy settings or security measures
          we may provide. We will retain your information for the time necessary to provide a
          requested service, realize our legitimate business purposes and to comply with the
          law. We will only retain personal information for the longer of the period if: (a)
          required by law, or (b) there is a time-bound determination business need.
          <br /><br />
          <h5>7. CHILDREN’S INFORMATION</h5>
          The Services are not intended to be used by minors under the age of 18, and we will
          not knowingly collect Personal Information from children under these age (as
          applicable). If you are under 18 years old or the age of majority in your jurisdiction
          of residence (whichever is higher), you will require the consent of your parent or
          legal guardian to agree to your use of the Services and to provide your Personal
          Information to us. We do not use an application or other mechanism to determine the
          age of users of the Services. All information provided to FMTG will be treated as if
          it was provided by an adult. If, however, we learn that a child has submitted
          information about himself/herself to us, we will delete the information as soon as
          possible.
          <br /><br />
          <h5>8. LINKS TO THIRD-PARTY WEBSITES</h5>
          The Services may contain links to and from third party websites of our business
          partners and various contact management services and other service providers. If you
          follow a link to any of these websites, please note that these websites have their own
          privacy policies and that we do not accept any responsibility or liability for their
          policies. Please check their individual privacy policies before you submit any
          Personal Information to those websites. Our provision of a link to any other website
          or location is for your convenience and does not indicate our endorsement of such
          other website or location or its contents. We have no control over, do not review, and
          cannot be responsible for these outside websites or their content. Please be aware
          that the terms of our Privacy Policy do not apply to these outside websites.
          <br /><br />
          <h5>9. UPDATES TO PRIVACY POLICY</h5>
          We may modify this Privacy Policy from time to time by posting updates on this page.
          If we make any significant changes to this Privacy Policy, we will contact you to
          inform you when required by law.
          <br /><br />
          <h5>10. CONTACT US</h5>
          Should you have any questions, concerns or feedback regarding this Privacy Policy,
          please contact us by email at breakmycoffee (@) gmail.com.
        </div>
      </section>

      <section class="sp-final">
        <div class="sp-sun"></div>
        <div class="sp-wrap">
          <div class="sp-kicker sp-kicker--center" v-reveal>One email. Every weekday.</div>
          <h2 v-reveal>Wake up<br /><em>already caught up.</em></h2>
          <p v-reveal>Join &gt;24,000 Malaysians. Unsubscribe anytime — no hard feelings.</p>
          <form class="sp-capture sp-capture--center" v-reveal @submit.prevent="subscribeFinal">
            <input
              ref="finalEmail"
              v-model="finalEmail"
              type="email"
              required
              placeholder="you@email.com"
              aria-label="Email address"
            />
            <button class="sp-go" type="submit" :class="{ 'sp-go--ok': finalState === 'done' }">
              <template v-if="finalState === 'brewing'">Brewing… ☕</template>
              <template v-else-if="finalState === 'done'">You're in ✓</template>
              <template v-else>Subscribe <span class="sp-arr">→</span></template>
            </button>
          </form>
          <div class="sp-referral sp-referral--center sp-referral--after" v-reveal>
            <span class="sp-referral-label">Referral code</span>
            <input
              v-model="referral"
              class="sp-referral-input"
              placeholder="Referral code"
              aria-label="Referral code"
            />
          </div>
          <div class="sp-note" v-reveal>Free forever · No spam · 3-minute read</div>
        </div>
        <footer>
          <span>Copyright © 2023 FINLIT MEDIA TECH GROUP SDN BHD (1348643-U)</span>
          <span>Brewed in Kuala&nbsp;Lumpur ☕</span>
          <span>
            <a @click="$router.push('/about')">About</a> ·
            <a href="https://thecoffeebreak.substack.com/archive" target="_blank" rel="noopener">Archive</a> ·
            <a @click="$router.push('/ilovetcb')">Support us</a> ·
            <a @click="$router.push('/privacy-policy')">Privacy Policy</a> ·
            <a @click="$router.push('/terms-of-service')">Terms of Service</a>
          </span>
        </footer>
      </section>
    </main>
  </div>
</template>

<script>
import axios from "axios";

const SUBSCRIBE_URL =
  "https://hukopzhug3.execute-api.ap-southeast-1.amazonaws.com/production/email/submit";

export default {
  name: "PrivacyPolicyNew",
  directives: {
    reveal: {
      inserted(el) {
        el.classList.add("sp-reveal");
        if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
          el.classList.add("sp-in");
          return;
        }
        const io = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                el.classList.add("sp-in");
                io.unobserve(el);
              }
            });
          },
          { threshold: 0.1 }
        );
        io.observe(el);
      },
    },
  },
  data() {
    return {
      menuOpen: false,
      scrolled: false,
      scrollProgress: 0,
      finalEmail: "",
      finalState: "idle",
      referral: "",
    };
  },
  mounted() {
    document.title = "Privacy Policy — The Coffee Break";
    const urlParams = new URLSearchParams(window.location.search);
    this.referral = urlParams.get("referral") || urlParams.get("ref") || "";
    window.addEventListener("scroll", this.onScroll, { passive: true });
    document.addEventListener("click", this.onDocClick);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.onScroll);
    document.removeEventListener("click", this.onDocClick);
  },
  methods: {
    onScroll() {
      const h = document.documentElement;
      const max = h.scrollHeight - h.clientHeight;
      this.scrollProgress = max > 0 ? (h.scrollTop / max) * 100 : 0;
      this.scrolled = h.scrollTop > 40;
    },
    onDocClick(e) {
      if (this.menuOpen && this.$refs.menuWrap && !this.$refs.menuWrap.contains(e.target)) {
        this.menuOpen = false;
      }
    },
    goto(path) {
      this.menuOpen = false;
      this.$router.push(path);
    },
    focusFinalEmail() {
      this.$refs.finalEmail.scrollIntoView({ behavior: "smooth", block: "center" });
      this.$refs.finalEmail.focus();
    },
    async subscribeFinal() {
      const emailVal = this.finalEmail.trim();
      if (!emailVal) return;
      this.finalState = "brewing";
      try {
        this.$gtag.event("subscribe", {
          event_label: "subscribe_privacy_new",
          value: emailVal,
        });
        await axios.post(SUBSCRIBE_URL, { email: emailVal, referral: this.referral.trim() });
        this.finalState = "done";
        this.finalEmail = "";
      } catch {
        this.finalState = "idle";
      }
    },
  },
};
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Bricolage+Grotesque:opsz,wght@12..96,400;12..96,600;12..96,800&family=Instrument+Serif:ital@0;1&family=Roboto+Mono:wght@400;500&display=swap");
</style>

<style scoped>
.sp {
  --paper: #faf7f0;
  --paper-2: #f3eee2;
  --ink: #101820;
  --ink-2: #3d4852;
  --ink-3: #7a8691;
  --blue: #007cb7;
  --blue-deep: #083d73;
  --sky: #e3f2fd;
  --volt: #ffdb00;
  --line: rgba(16, 24, 32, 0.14);
  --serif: "Instrument Serif", Georgia, serif;
  --grotesk: "Bricolage Grotesque", "Helvetica Neue", sans-serif;
  --mono: "Roboto Mono", Menlo, monospace;
  --ease: cubic-bezier(0.16, 1, 0.3, 1);

  font-family: var(--grotesk);
  background: var(--paper);
  color: var(--ink);
  -webkit-font-smoothing: antialiased;
  overflow-x: hidden;
  position: relative;
}
.sp *,
.sp *::before,
.sp *::after {
  box-sizing: border-box;
}
.sp ::selection {
  background: var(--volt);
  color: var(--ink);
}

/* brew bar */
.sp-brew {
  position: fixed;
  top: 0;
  left: 0;
  height: 3px;
  background: var(--blue);
  z-index: 65;
}

/* nav */
.sp-nav {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 50;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 18px 32px;
  transition: background 0.3s, box-shadow 0.3s;
}
.sp-scrolled {
  background: rgba(250, 247, 240, 0.92);
  backdrop-filter: blur(12px);
  box-shadow: 0 1px 0 var(--line);
}
.sp-lockup {
  display: flex;
  align-items: center;
  gap: 12px;
  text-decoration: none;
  color: var(--ink);
  cursor: pointer;
}
.sp-lockup img {
  height: 30px;
  display: block;
}
.sp-lockup span {
  font-weight: 800;
  font-size: 16px;
  letter-spacing: -0.02em;
}
.sp-nav-actions {
  display: flex;
  align-items: center;
  gap: 14px;
}
.sp-menu-wrap {
  position: relative;
}
.sp-menu-btn {
  font-family: var(--grotesk);
  font-weight: 800;
  font-size: 13px;
  letter-spacing: 0.02em;
  color: var(--ink);
  background: transparent;
  border: 1.5px solid var(--line);
  border-radius: 999px;
  padding: 10.5px 20px;
  cursor: pointer;
  transition: border-color 0.2s, background 0.2s;
}
.sp-menu-btn:hover {
  border-color: var(--blue);
  background: rgba(0, 124, 183, 0.06);
}
.sp-menu-dropdown {
  position: absolute;
  top: calc(100% + 10px);
  right: 0;
  min-width: 200px;
  background: var(--paper);
  border: 1.5px solid var(--line);
  border-radius: 16px;
  padding: 10px;
  box-shadow: 0 20px 40px rgba(16, 24, 32, 0.14);
  display: none;
  flex-direction: column;
}
.sp-menu-dropdown.sp-menu-open {
  display: flex;
}
.sp-menu-dropdown a {
  font-family: var(--grotesk);
  font-size: 14px;
  font-weight: 600;
  color: var(--ink);
  text-decoration: none;
  padding: 10px 12px;
  border-radius: 10px;
  cursor: pointer;
  transition: background 0.2s, color 0.2s;
}
.sp-menu-dropdown a:hover {
  background: var(--sky);
  color: var(--blue);
}
.sp-heart {
  color: #e5484d;
  vertical-align: -2px;
  margin-right: 4px;
}
/* desktop: list the links inline instead of behind the Menu button */
@media (min-width: 961px) {
  .sp-menu-btn {
    display: none;
  }
  .sp-menu-dropdown {
    position: static;
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 2px;
    min-width: 0;
    padding: 0;
    background: transparent;
    border: none;
    box-shadow: none;
  }
  .sp-menu-dropdown a {
    white-space: nowrap;
  }
}
.sp-cta {
  font-family: var(--grotesk);
  font-weight: 800;
  font-size: 13px;
  letter-spacing: 0.02em;
  color: var(--paper);
  background: var(--ink);
  border: none;
  border-radius: 999px;
  padding: 12px 22px;
  cursor: pointer;
  transition: transform 0.3s var(--ease), background 0.3s;
}
.sp-cta:hover {
  background: var(--blue);
  transform: scale(1.05);
}
@media (max-width: 720px) {
  .sp-nav-actions {
    gap: 8px;
  }
  .sp-menu-btn {
    padding: 9px 14px;
    font-size: 12px;
  }
  .sp-cta {
    padding: 10px 16px;
    font-size: 12px;
  }
  .sp-nav {
    padding: 14px 18px;
  }
}
@media (max-width: 420px) {
  .sp-lockup span {
    display: none;
  }
}

/* legal hero */
.ab-legal-hero {
  padding: 150px 0 60px;
}
.sp-kicker {
  font-family: var(--mono);
  font-size: 12px;
  letter-spacing: 0.22em;
  text-transform: uppercase;
  color: var(--ink-3);
  display: flex;
  align-items: center;
  gap: 14px;
  margin-bottom: 20px;
}
.sp-kicker::before {
  content: "";
  width: 44px;
  height: 1px;
  background: currentColor;
}
.sp-kicker--center {
  justify-content: center;
}
.sp-display {
  font-weight: 800;
  font-size: clamp(48px, 9vw, 140px);
  line-height: 0.92;
  letter-spacing: -0.04em;
  margin: 0;
  text-transform: uppercase;
}
.sp-row {
  display: block;
  overflow: hidden;
}
.sp-row > span {
  display: inline-block;
  transform: translateY(110%);
  animation: sp-rise 1.1s var(--ease) forwards;
}
.sp-row:nth-child(2) > span {
  animation-delay: 0.12s;
}
@keyframes sp-rise {
  to {
    transform: translateY(0);
  }
}
.sp-display em {
  font-family: var(--serif);
  font-style: italic;
  font-weight: 400;
  text-transform: none;
  letter-spacing: -0.01em;
  color: var(--blue);
}
.sp-cupword {
  position: relative;
  white-space: nowrap;
}
.sp-cupword::after {
  content: "";
  position: absolute;
  left: -2%;
  right: -2%;
  bottom: 6%;
  height: 0.18em;
  background: var(--volt);
  z-index: -1;
  transform: scaleX(0);
  transform-origin: left;
  animation: sp-swipe 0.8s var(--ease) 1s forwards;
}
@keyframes sp-swipe {
  to {
    transform: scaleX(1);
  }
}
@media (max-width: 720px) {
  .ab-legal-hero {
    padding: 120px 0 40px;
  }
}

/* legal article */
.ab-legal {
  padding: 20px 0 100px;
}
.ab-legal-wrap {
  max-width: 780px;
  font-size: 16px;
  line-height: 1.8;
  color: var(--ink-2);
}
.ab-legal-wrap >>> h5 {
  font-family: var(--grotesk);
  font-weight: 800;
  font-size: 20px;
  letter-spacing: -0.01em;
  color: var(--ink);
  margin: 48px 0 16px;
}
.ab-legal-wrap >>> ul {
  margin: 14px 0 20px;
  padding-left: 22px;
}
.ab-legal-wrap >>> li {
  margin-bottom: 10px;
}
.ab-legal-wrap >>> li::marker {
  color: var(--blue);
}
.ab-legal-wrap >>> b {
  color: var(--ink);
  font-weight: 700;
}
@media (max-width: 720px) {
  .ab-legal {
    padding: 8px 0 60px;
  }
  .ab-legal-wrap {
    font-size: 15px;
  }
}

/* shared */
.sp-wrap {
  max-width: 1240px;
  margin: 0 auto;
  padding: 0 32px;
}
@media (max-width: 720px) {
  .sp-wrap {
    padding: 0 18px;
  }
}
.sp-reveal {
  opacity: 0;
  transform: translateY(24px);
  transition: opacity 0.9s var(--ease), transform 0.9s var(--ease);
}
.sp-reveal.sp-in {
  opacity: 1;
  transform: none;
}

.sp-referral {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 16px;
}
.sp-referral--center {
  justify-content: center;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 8px;
  max-width: 520px;
}
.sp-referral--after {
  margin-top: 20px;
  margin-bottom: 0;
  opacity: 0.75;
}
.sp-referral-label {
  font-family: var(--mono);
  font-size: 11px;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: var(--ink-3);
  white-space: nowrap;
}
.sp-referral-input {
  height: 36px;
  padding: 0 16px;
  font-family: var(--grotesk);
  font-size: 13px;
  color: var(--ink);
  background: transparent;
  border: 1.5px solid var(--line);
  border-radius: 999px;
  outline: none;
  flex: 1;
  transition: border-color 0.2s;
}
.sp-referral-input::placeholder {
  color: var(--ink-3);
}
.sp-referral-input:focus {
  border-color: var(--blue);
}
.sp-capture {
  display: flex;
  gap: 10px;
  flex: 1;
  max-width: 520px;
  min-width: 300px;
}
.sp-capture--center {
  margin: 0 auto;
  justify-content: center;
}
.sp-capture input {
  flex: 1;
  line-height: 1;
  padding: 9px 16px;
  font-family: var(--grotesk);
  font-size: 13px;
  color: var(--ink);
  background: transparent;
  border: 1.5px solid var(--line);
  border-radius: 999px;
  outline: none;
  transition: border-color 0.2s, background 0.2s;
}
.sp-capture input::placeholder {
  color: var(--ink-3);
}
.sp-capture input:focus {
  border-color: var(--blue);
  background: #fff;
}
.sp-go {
  height: 36px;
  padding: 0 20px;
  border: none;
  border-radius: 999px;
  cursor: pointer;
  background: var(--blue);
  color: #fff;
  font-family: var(--grotesk);
  font-weight: 800;
  font-size: 13px;
  display: inline-flex;
  align-items: center;
  gap: 10px;
  white-space: nowrap;
  transition: background 0.25s;
  position: relative;
}
.sp-go:hover {
  background: var(--blue-deep);
}
.sp-go--ok {
  background: #27ae60;
}
.sp-arr {
  transition: transform 0.3s var(--ease);
  display: inline-block;
}
.sp-go:hover .sp-arr {
  transform: translateX(5px);
}
@media (max-width: 520px) {
  .sp-capture {
    flex-direction: column;
    min-width: 0;
    width: 100%;
  }
  .sp-capture input,
  .sp-go {
    width: 100%;
  }
  .sp-go {
    justify-content: center;
  }
}

/* final CTA */
.sp-final {
  padding: 150px 0 60px;
  text-align: center;
  position: relative;
  overflow: hidden;
}
.sp-sun {
  position: absolute;
  left: 50%;
  bottom: -32vw;
  transform: translateX(-50%);
  width: 64vw;
  height: 64vw;
  border-radius: 50%;
  background: radial-gradient(circle at 50% 30%, var(--sky) 0%, rgba(227, 242, 253, 0) 70%);
  pointer-events: none;
}
.sp-final h2 {
  font-weight: 800;
  font-size: clamp(44px, 8vw, 120px);
  line-height: 0.95;
  letter-spacing: -0.04em;
  text-transform: uppercase;
  margin: 0 0 18px;
  position: relative;
}
.sp-final h2 em {
  font-family: var(--serif);
  font-style: italic;
  font-weight: 400;
  text-transform: none;
  color: var(--blue);
}
.sp-final p {
  font-size: 17px;
  color: var(--ink-2);
  margin: 0 0 44px;
  position: relative;
}
.sp-final .sp-capture {
  margin: 0 auto;
  position: relative;
}
.sp-note {
  margin-top: 18px;
  font-family: var(--mono);
  font-size: 11.5px;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: var(--ink-3);
  position: relative;
}

@media (max-width: 720px) {
  .sp-final {
    padding: 90px 0 40px;
  }
  footer {
    margin-top: 64px;
  }
}

footer {
  margin-top: 130px;
  border-top: 1.5px solid var(--ink);
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  padding: 26px 32px;
  font-family: var(--mono);
  font-size: 11.5px;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: var(--ink-3);
  flex-wrap: wrap;
  position: relative;
  background: var(--paper);
}
footer a {
  color: var(--ink);
  text-decoration: none;
  cursor: pointer;
}
footer a:hover {
  color: var(--blue);
}

@media (prefers-reduced-motion: reduce) {
  .sp-row > span {
    animation: none;
    transform: none;
  }
  .sp-cupword::after {
    animation: none;
    transform: scaleX(1);
  }
  .sp-reveal {
    opacity: 1;
    transform: none;
    transition: none;
  }
}
</style>
